import { FC, JSXElementConstructor, ReactElement } from 'react';
import { Stack } from '@zoopla-eng/zds/stack';
import { Box } from '@zoopla-eng/zds/box';

export type LegendProps = {
    children: ReactElement<unknown, string | JSXElementConstructor<unknown>>[];
};

export const Legend: FC<LegendProps> = ({ children }) => {
    return (
        <Box fontGroup="fork">
            <Stack flexDirection="row" columnGap="S100" alignItems="center">
                {children}
            </Stack>
        </Box>
    );
};
